import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE =
  "Calculatrice de puissance moteur - Calcul de la puissance en chevaux";
const DESCRIPTION =
  "Calculatrice de puissance moteur - Calcul de la puissance en chevaux. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "engine horsepower, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/engine-horsepower";
function EngineHorsepowerCalculator() {
  const [torque, setTorque] = useState("");
  const [rpm, setRpm] = useState("");
  const [horsepower, setHorsepower] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!torque || !rpm) {
      setError("Veuillez entrer le couple et la vitesse correctement");
      setHorsepower("");
      return;
    }
    const torqueValue = parseFloat(torque);
    const rpmValue = parseFloat(rpm);
    if (isNaN(torqueValue) || isNaN(rpmValue) || torqueValue <= 0 || rpmValue <= 0) {
      setError("Veuillez entrer des valeurs valides et positives");
      setHorsepower("");
      return;
    }
    const hp = (torqueValue * rpmValue) / 5252;
    setHorsepower(hp.toFixed(2));
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la puissance moteur</h2>
                <p>
                  La puissance d'un moteur est calculée à partir du couple et de la vitesse de rotation en utilisant la formule suivante :
                </p>
                <p>
                  <b>Puissance (CV) = (Couple (Nm) × Vitesse (tr/min)) / 5252</b>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Couple (Nm)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="100"
                        value={torque}
                        onChange={(e) => setTorque(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Vitesse (tr/min)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="3000"
                        value={rpm}
                        onChange={(e) => setRpm(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      horsepower !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Puissance : {horsepower} CV
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default EngineHorsepowerCalculator;
